// Mastery Levels
export const MASTERY_LEVEL_MIN = 0;
export const MASTERY_LEVEL_MAX = 5;
export const MASTERY_THRESHOLD_MASTERED = 4; // Level 4+ is considered mastered
export const MASTERY_THRESHOLD_LEARNING = 2; // Level 2-3 is considered learning

// Practice Mode Config
export const PRACTICE_DECK_SIZE = 20;
export const PRACTICE_MIX_MASTERED = 0.05; // 5%
export const PRACTICE_MIX_REVIEW = 0.15; // 15%
export const PRACTICE_MIX_LEARNING = 0.1; // 10%
export const PRACTICE_MIX_NEW = 0.7; // 70%

// Test Mode Config
export const TEST_PASS_THRESHOLD = 0.6; // 60%
export const MINI_TEST_COUNT = 10;
export const MINI_TEST_TIME = 10; // minutes
export const FULL_TEST_COUNT = 50;
export const FULL_TEST_TIME = 50; // minutes

// Mode Labels
export const LABEL_MODE_PRACTICE = "Practice Mode";
export const LABEL_MODE_MINI_TEST = "Mini Exam";
export const LABEL_MODE_FULL_MOCK_EXAM = "Full Exam";
export const LABEL_MODE_STATS = "Statistics & Progress";
export const LABEL_MODE_FLASHCARD = "Flashcards";

// Display Labels
export const LABEL_MASTERED = "Mastered";
export const LABEL_LEARNING = "Learning";
export const LABEL_INCORRECT = "Needs Review";
export const LABEL_NEW = "New";

// Emojis for Effects
export const EMOJIS_PRACTICE = ["✨", "⭐", "🌟"];
export const EMOJIS_STATS = ["📊", "📈", "📉", "💯", "🔢"];
export const EMOJIS_TEST_BASE = ["🇨🇭", "🦁", "🔔", "🐮", "🏔️"];
export const EMOJIS_TIMED = ["⏱️", "⏳"];
export const EMOJIS_FULL_EXAM = ["💪", "🔥", "🧠"];
export const EMOJIS_FLASHCARD = ["🃏", "🧠", "🔄"];
export const EMOJIS_SUCCESS = ["✨", "🌟", "🎉", "🥳", "🏆"];

// Emojis for Topics
export const SECTION_EMOJIS = {
  "1 Demokratie und Föderalismus": "🗳️",
  "2 Sozialstaat und Zivilgesellschaft": "🤝",
  "3 Geschichte": "📜",
  "4 Geografie": "🗺️",
  "5 Kultur und Alltagskultur": "🎭",
};
